import router from './index'

export default [
  {
    name: 'Main',
    path: '/main',
    component: () => import('@/views/PC/index.vue'),
    children: [
      {
        path: 'project/:projectId',
        name: 'Project',
        component: () => import('@/views/PC/ConstructionImplement.vue'),
        redirect: to => {
          return { name: 'Information' }
        },
        children: [
          {
            path: 'member',
            name: 'Member',
            meta: {
              sideBarCatalog: 'main',
              title: '成員與權限'
            },
            component: () => import('@/views/PC/Member')
          },
          {
            path: 'daily-records',
            name: 'DailyRecords',

            meta: {
              sideBarCatalog: 'main',
              title: '施工日誌',
              isAddDailyRecord: true
            },
            component: () => import('@/views/PC/DailyRecords'),
            children: [
              {
                path: ':dailyRecordId',
                name: 'DailyRecord',
                meta: {
                  sideBarCatalog: 'main',
                  title: '施工日誌',
                  isModal: true,
                  isAddDailyRecord: false
                },
                component: () => import('@/components/resource/m_dailyRecord/DailyRecord'),
                beforeEnter: async (to, from, next) => {
                  await router.app.$store.dispatch('dailyRecord/getDailyRecordAndStore', to.params.dailyRecordId)
                  next()
                }
              }
            ]
          },
          {
            path: 'inspectionList/inspections',
            name: 'Inspections',
            meta: {
              sideBarCatalog: 'main',
              title: '自主檢查'
            },
            component: () => import('@/components/resource/m_inspection/Inspections'),
            children: [
              {
                path: ':inspectionId',
                name: 'Inspection',
                meta: {
                  sideBarCatalog: 'main',
                  title: '自主檢查',
                  isModal: true,
                  isAddInspection: false
                },
                component: () => import('@/views/PC/Inspection'),
                beforeEnter: async (to, from, next) => {
                  await router.app.$store.dispatch('inspection/storeInspection', to.params.inspectionId)
                  next()
                }
              }
            ]
          },
          {
            path: 'contract',
            name: 'Contract',
            meta: {
              sideBarCatalog: 'main',
              title: '契約工項'
            },
            component: () => import('@/views/PC/Contracts')

          },
          {
            path: 'error-records',
            name: 'ErrorRecords',
            meta: {
              sideBarCatalog: 'main',
              title: '缺失改善'
            },
            component: () => import('@/components/resource/m_errorRecord/ErrorRecords')

          },
          {
            path: 'error-records/:errorRecordId',
            name: 'ErrorRecord',
            meta: {
              sideBarCatalog: 'main',
              title: ''
            },
            component: () => import('@/components/resource/m_errorRecord/ErrorRecord')
          },
          {
            path: 'review-applications',
            name: 'ReviewApplications',
            meta: {
              sideBarCatalog: 'main',
              title: '送審管制'
            },
            component: () => import('@/views/PC/ReviewApplications')

          },
          {
            path: 'review-applications/:reviewApplicationId',
            name: 'ReviewApplication',
            meta: {
              sideBarCatalog: 'main',
              title: ''
            },
            component: () => import('@/views/PC/ReviewApplication')
          },
          {
            path: 'test-record-item-management',
            name: 'TestRecordItemManagement',
            meta: {
              sideBarCatalog: 'main',
              title: '檢試驗項目管理'
            },
            component: () => import('@/views/PC/TestRecordItemManagement')
          },
          {
            path: 'test-records',
            name: 'TestRecords',
            meta: {
              sideBarCatalog: 'main',
              title: '檢(試)驗管制'
            },
            component: () => import('@/views/PC/TestRecords')
          },
          {
            path: 'test-records/:testRecordId',
            name: 'TestRecord',
            meta: {
              sideBarCatalog: 'main',
              title: ''
            },
            component: () => import('@/views/PC/TestRecord')
          },
          {
            path: 'drawing-management',
            name: 'FileManagement',
            meta: {
              sideBarCatalog: 'main',
              title: '檔案管理'
            },
            component: () => import('@/components/resource/m_file/FileManagement')
          },
          {
            path: 'pay-records',
            name: 'PayRecords',
            meta: {
              sideBarCatalog: 'main',
              title: '估驗計價'
            },
            component: () => import('@/views/PC/PayRecords')
          },
          {
            path: 'progress-report',
            name: 'ProgressReport',
            meta: {
              sideBarCatalog: 'main',
              title: '進度報告'
            },
            component: () => import('@/views/PC/ProgressReport')
          },
          {
            path: 'pay-records/:payRecordId',
            name: 'PayRecord',
            meta: {
              sideBarCatalog: 'main',
              title: ''
            },
            component: () => import('@/views/PC/PayRecord')
          },
          {
            path: 'report',
            name: 'Report',
            meta: {
              sideBarCatalog: 'main',
              title: '即時損益報告'
            },
            component: () => import('@/views/PC/Report')
          },
          {
            path: 'information',
            name: 'Information',
            meta: {
              sideBarCatalog: 'main',
              title: '基本資料'
            },
            component: () => import('@/views/PC/Information')
          },
          {
            path: 'schedule',
            name: 'Schedule',
            meta: {
              sideBarCatalog: 'main',
              title: '進度表'
            },
            component: () => import('@/views/PC/Schedule')
          },
          {
            path: 'template',
            name: 'Template',
            meta: {
              sideBarCatalog: 'main',
              title: '樣板'
            },
            component: () => import('@/views/PC/Template')
          },
          {
            path: 'inspectionTypes',
            name: 'InspectionTypes',
            meta: {
              sideBarCatalog: 'main',
              title: '自主檢查類型設定'
            },
            component: () => import('@/views/PC/InspectionTypes')
          },
          {
            path: 'manMachineManagement',
            name: 'ManMachineManagement',
            meta: {
              sideBarCatalog: 'main',
              title: '人機項目管理'
            },
            component: () => import('@/views/PC/ManMachineManagement')
          },
          {
            path: 'appointmentSheetManagement',
            name: 'AppointmentSheetManagement',
            meta: {
              sideBarCatalog: 'main',
              title: '通報單管理'
            },
            component: () => import('@/components/resource/m_appointment/AppointmentSheetList'),
            beforeEnter: async (to, from, next) => {
              if ('parent' in router.app.$store.state.project.current) {
                await router.app.$store.dispatch('project/getProjectItemAndStore', router.app.$store.state.project.current.parent)
              } else {
                await router.app.$store.dispatch('project/getProjectItemAndStore', router.app.$store.state.project.current._id)
              }
              next()
            }
          },
          {
            path: 'appointmentSheet',
            name: 'AppointmentSheet',
            meta: {
              sideBarCatalog: 'main',
              title: '通報單'
            },
            component: () => import('@/components/resource/m_appointment/AppointmentSheet')
          },
          {
            path: 'appointmentSheet/inspection/list',
            name: 'AppointmentInspections',
            meta: {
              sideBarCatalog: 'appointmentSheet',
              title: '自主檢查'
            },
            component: () => import('@/components/resource/m_inspection/Inspections'),
            children: [
              {
                path: ':inspectionId',
                name: 'AppointmentInspection',
                meta: {
                  sideBarCatalog: 'appointmentSheet',
                  title: '自主檢查',
                  isModal: true,
                  isAddInspection: false
                },
                component: () => import('@/views/PC/Inspection'),
                beforeEnter: async (to, from, next) => {
                  await router.app.$store.dispatch('inspection/storeInspection', to.params.inspectionId)
                  next()
                }
              }
            ]
          },
          {
            path: 'AppointmentSheet/error-records',
            name: 'AppointmentErrorRecords',
            meta: {
              sideBarCatalog: 'appointmentSheet',
              title: '缺失改善'
            },
            component: () => import('@/components/resource/m_errorRecord/ErrorRecords')
          }
        ],
        beforeEnter: async (to, from, next) => {
          await router.app.$store.dispatch('project/getProjectItemAndStore', to.params.projectId)
          next()
        }
      },
      {
        path: 'cost-benefit-analysis',
        name: 'CostBenefitAnalysis',
        component: () => import('@/views/PC/CostBenefitAnalysis.vue'),
        redirect: to => {
          return { name: 'DetailPrice' }
        },
        children: [
          {
            path: 'detail-price',
            name: 'DetailPrice',
            meta: {
              sideBarCatalog: 'costBenefitAnalysis',
              title: '詳細價目'
            },
            component: () => import('@/views/PC/DetailPrice')
          },
          {
            path: 'price-management',
            name: 'PriceManagement',

            meta: {
              sideBarCatalog: 'costBenefitAnalysis',
              title: '價格庫'
            },
            component: () => import('@/views/PC/PriceManagement')
          } ]
      },
      {
        path: 'picture-management-module',
        name: 'PictureManagementModule',
        component: () => import('@/views/PC/pictureManagementModule/index.vue'),
        redirect: to => {
          return { name: 'MapSearch' }
        },
        children: [
          {
            path: 'map-search',
            name: 'MapSearch',
            meta: {
              sideBarCatalog: 'pictureModule',
              title: '地圖檢索'
            },
            component: () => import('@/views/PC/pictureManagementModule/MapSearch')
          },
          {
            path: 'pictures',
            name: 'Pictures',
            meta: {
              sideBarCatalog: 'pictureModule',
              title: '所有照片'
            },
            component: () => import('@/views/PC/pictureManagementModule/Pictures')
          }
        ]
      },
      {
        path: 'root',
        name: 'RootSetting',
        component: () => import('@/views/PC/rootSetting/index.vue'),
        redirect: to => {
          return { name: 'SubscriberManagement' }
        },
        children: [
          {
            path: 'subscriber',
            name: 'SubscriberManagement',
            meta: {
              title: '訂閱者管理',
              sideBarCatalog: 'rootSetting'
            },
            component: () => import('@/views/PC/rootSetting/SubscriberManagement')
          },
          {
            path: 'inspectionTypes',
            name: 'Root_inspectionTypes',
            meta: {
              title: '自主檢查類型庫',
              sideBarCatalog: 'rootSetting'
            },
            component: () => import('@/views/PC/rootSetting/Root_inspectionTypes')
          },
          {
            path: 'projectHandler',
            name: 'ProjectHandler',
            meta: {
              title: '專案代管',
              sideBarCatalog: 'rootSetting'
            },
            component: () => import('@/views/PC/rootSetting/ProjectHandler')
          }
        ]
      }
    ]

  }

]



// WEBPACK FOOTER //
// ./src/router/pcRoutes.js